import React from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';

export default function GlobalDbnRoutingPacksBasicInfoComponent({
  domains,
  handleInnerFormChange,
  handleInnerChange,
  selectedCategory,
  BluePrinyResgistryList,
  CommercialTier,
  subselectedCategory
}: any) {
  const formatDateOnly = (dateValue: string) => {
    if (!dateValue) return "";
    return new Date(dateValue).toISOString().split("T")[0];
  };
  return (
    <>
      <AccordionContainer
        headerTitle="New Service Category Group"
        expandedPanel="userInfo"
        child={
          <div className="grid md:grid-cols-3 gap-4">

            <InputContainer
              label="Pack Code"
              name="Code"
              type="text"
              value={selectedCategory?.PackCode}
              isDisabled={!!selectedCategory?.GlobalRoutingPackId}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  "PackCode"
                );
              }}
            />

            <InputContainer
              label="Pack Name"
              name="Name"
              type="text"
              value={selectedCategory?.PackName}
              isDisabled={!!selectedCategory?.GlobalRoutingPackId}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  "PackName"
                );
              }}
            />
            <div className="text-black">
              <InputContainer
                label="Commercial Tyre"
                labelField="Text"
                list={CommercialTier}
                type="select"
                optionName="Select commercial Tyre"
                value={selectedCategory?.CommercialTierId}
                valueField="Value"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    Number(event.target.value),
                    "CommercialTierId"
                  );
                }}
              />
            </div>
            <InputContainer
              label="BluePrint Registry"
              labelField="Name"
              list={BluePrinyResgistryList}
              type="multiselect"
              optionName="Select BluePrint Registry"
              value={selectedCategory?.GlobalBluePrintRegistryId || []}
              valueField="GlobalBluePrintRegistryId"
              onValueChange={(newValue: any) => {
                const channelData: any = newValue.map((option: any) => option?.value)

                handleInnerFormChange(
                  channelData,
                  "GlobalBluePrintRegistryId"
                );

              }}

            />
            <div className="md:col-span-3">
              <InputContainer
                label="Description"
                name="Description"
                type="text"
                value={selectedCategory?.Description}
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    "Description"
                  );
                }}
              />
            </div>

            <InputContainer
              label="Effective From"
              name="EffectiveFrom"
              type="date"
              value={formatDateOnly(selectedCategory?.CreatedOnUtc)}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  "CreatedOnUtc"
                );
              }}
            />

            <InputContainer
              label="Effective To"
              name="EffectiveTo"
              type="date"
              value={formatDateOnly(selectedCategory?.ModifiedOnUtc)}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  "ModifiedOnUtc"
                );
              }}
            />

          </div>
        }
      />
    </>
  );
}